const downloadCounts = new Map<string, number>();

/**
 * Save a compressed TLF bundle with a duplicate suffix before its file extension.
 *
 * @param bundle - Verified compressed bundle bytes
 * @param hierarchyName - Hierarchy name used to create a safe download filename
 * @returns void
 */
export const saveTlfBundle = (bundle: Blob, hierarchyName: string): void => {
  const safeHierarchyName = hierarchyName.replace(/[\\/:*?"<>|]/g, "_");
  const nameKey = safeHierarchyName.toLowerCase();
  const downloadCount = downloadCounts.get(nameKey) ?? 0;
  downloadCounts.set(nameKey, downloadCount + 1);
  const duplicateSuffix = downloadCount > 0 ? ` (${downloadCount})` : "";
  const objectUrl = URL.createObjectURL(bundle);
  const link = document.createElement("a");
  link.href = objectUrl;
  link.download = `${safeHierarchyName}${duplicateSuffix}-tlfbundle.gz`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(objectUrl);
};
